import React  from 'react'

import { withStyles } from '@material-ui/core/styles/index'
import { withRouter } from 'react-router-dom'

import { FuseNavigation, FuseLayouts } from '../../@fuse'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import DisplayObject from './DisplayObject' ;

import navigation from '../locale/fr/navigation'
import roles      from '../roles'

import user from '../user'

import cloneDeep from 'lodash/cloneDeep';

const styles = () => ({ root: {} });

class NavbarContent extends DisplayObject
{
    constructor( props )
    {
        super( props ) ;
        this.change = this.change.bind(this) ;
        user.change.connect( this.change ) ;
    }

    change()
    {
        if( this.mounted )
        {
            this.forceUpdate();
        }
    }

    render()
    {
        return <FuseNavigation navigation={this.generate(cloneDeep(navigation))} layout={FuseLayouts[this.props.layoutStyle].type}/>;
    }

    generate( items )
    {
        let list = [];

        if( items && (items instanceof Array) && (items.length > 0) )
        {
            items.forEach( item =>
            {
                switch( item.type )
                {
                    case 'collapse' :
                    case 'divider' :
                    {
                        list.push(item) ;
                        break ;
                    }
                    case 'group'    :
                    {
                        item.children = this.generate(item.children) ;
                        if( (item.children instanceof Array) && (item.children.length > 0) )
                        {
                            list.push(item) ;
                        }
                        break ;
                    }
                    case 'item' :
                    {
                        let url = null ;
                        if( (typeof(item.url) === 'string') || (item.url instanceof String) )
                        {
                            url = item.url ;
                            if( url.indexOf('/') === 0 )
                            {
                                url = url.slice(1) ;
                            }
                            url = url.split('/')[0] ;

                            if( roles.hasOwnProperty(url))
                            {
                                let role = roles[url] ;
                                if( role )
                                {
                                    if( user.scope && user.scope.hasOwnProperty(url) )
                                    {
                                        let scope = user.scope[url];
                                        if ((role instanceof Array) ? (role.indexOf(scope) > -1) : (role === scope))
                                        {
                                            list.push(item);
                                        }
                                    }
                                    else if( (role instanceof Array) ? (role.indexOf('guest') > -1) : (role === 'guest') )
                                    {
                                        list.push(item);
                                    }
                                }
                                else
                                {
                                    list.push(item);
                                }
                            }
                        }
                        break ;
                    }
                    default :
                    {

                    }
                }
            })
        }
        return list ;
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({}, dispatch);
}

function mapStateToProps( {fuse} )
{
    return { layoutStyle: fuse.settings.current.layout.style }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(NavbarContent)));



// WEBPACK FOOTER //
// ./src/app/display/NavbarContent.js